import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { ToastController, LoadingController,Platform, AlertController } from '@ionic/angular';
import {Network} from '@ionic-native/network/ngx';
import { APIService } from '../services/APIService';
import { Helper } from '../services/Helper';
@Component({
  selector: 'app-forgot-pass',
  templateUrl: './forgot-pass.page.html',
  styleUrls: ['./forgot-pass.page.scss'],
})
export class ForgotPassPage implements OnInit {

  credentialsForm: FormGroup;
  Regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  isLoggedIn:false;
  loader: any;


  constructor(private formBuilder: FormBuilder, private router:Router,public toastController: ToastController,private network: Network,public loadingController: LoadingController,private apiservice: APIService,private helper:Helper,private platform:Platform,private alertCtrl:AlertController) {

    this.credentialsForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
 
      });

  }


ionViewWillEnter(){
  this.platform.backButton.subscribeWithPriority(1, () => {
    this.router.navigate(['/login']);
  });

}

  
  ngOnInit() {
  }


  generate(value: any) {
    console.log("login function")
    if (!value.email || !this.credentialsForm.controls.email.valid) {
      this.presentToast('Please Enter Email address!');
    } else if (!(this.network.type !== 'none' && this.network.type !== 'unknown')) {
      this.presentToast('Please on Internet Connection!');
    } else {


      this.presentLoading().then(() => {
            this.apiservice.forgotpassword({"email":value.email}).subscribe(
                response => {
                    console.log('responseBody' , response.body);
                    this.helper.presentToastSuccess(response.body.message);
                    this.router.navigate(['/login']);
                     this.dismissLoading();

                }, error => {
                      this.dismissLoading();
                    console.log(error);
                    this.helper.presentToastError(error.error.message);
                });
        });
    }
  }



  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      cssClass: 'my-custom-class'
    });
    toast.present();
  }


  async presentLoading() {
    this.loader = await this.loadingController.create({
        translucent: true
    });
    await this.loader.present();
}

async dismissLoading() {
  await this.loader.dismiss();
}


}
